import { css } from '@emotion/react';
import { theme } from 'global';

export const rootStyle = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 24px;
`;

const borderRadiusStyle = '8px';
const heightStyle = '48px';

export const buttonStyle = css`
  min-width: 133px;
  height: ${heightStyle};
  border-radius: ${borderRadiusStyle};

  @media screen and (max-width: ${theme.breaks.xs}px) {
    width: 100%;
  }
`;

export const textFieldStyle = css`
  margin-right: 0;
  height: ${heightStyle};
  background-color: #f8f8f9;
  border-radius: ${borderRadiusStyle};
  min-width: 333px;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    width: 100%;
  }

  > .MuiOutlinedInput-root {
    font-family: Sharp Grotesk;
    height: ${heightStyle};
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.5px;
  }

  > .MuiFormHelperText-root {
    margin-left: 0;
  }
`;
